gsap.registerPlugin(ScrollTrigger);
if (window.innerWidth > 768) {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".agt-wd-landing-about-wrapper",
      start: "top 80%", // start animation when section enters viewport
      end: "bottom+=50% top",
      scrub: true, // smooth scroll-based animation
      invalidateOnRefresh: true, // recalculates positions on resize/orientation change
    },
  });

  // Animate IN
  tl.to(".agt-wd-landing-about-content", {
    x: -150,
    scale: 1.5,
    opacity: 1,
    duration: 2500,
    ease: "power2.out",
  });

  tl.to(
    ".agt-wd-landing-about-img",
    {
      x: 10,
      opacity: 1,
      scale: 1.12,
      duration: 1000,
      ease: "power2.out",
    },
    "<"
  ); // Start at the same time as above

  // Animate OUT (fade back to 0 after scroll)
  tl.to([".agt-wd-landing-about-content", ".agt-wd-landing-about-img"], {
    opacity: 0,
    duration: 0.4,
    ease: "power1.in",
  });

  const tl1 = gsap.timeline({
    scrollTrigger: {
      trigger: ".agt-wd-curated-collection-wrapper",
      start: "top 80%", // start animation when section enters viewport
      end: "bottom+=50% top",
      scrub: true, // smooth scroll-based animation
      invalidateOnRefresh: true, // recalculates positions on resize/orientation change
    },
  });

  // Animate IN
  tl1.to(".agt-item-collection-left", {
    x: 50,
    opacity: 1,
    scale: 1,
    duration: 2500,
    ease: "power2.out",
  });

  tl1.to(
    ".agt-item-collection-center",
    {
      y: -0,
      opacity: 1,
      scale: 1,
      duration: 1000,
      ease: "power2.out",
    },
    "<"
  ); // Start at the same time as above
  tl1.to(
    ".agt-item-collection-right",
    {
      x: -50,
      scale: 1,
      opacity: 1,
      duration: 2500,
      ease: "power2.out",
    },
    "<"
  );
  // Animate OUT (fade back to 0 after scroll)
  tl1.to(
    [
      ".agt-item-collection-left",
      ".agt-item-collection-center",
      ".agt-item-collection-right",
    ],
    {
      opacity: 0,
      duration: 0.4,
      scale: 1,
      ease: "power1.in",
    }
  );

  const tl2 = gsap.timeline({
    scrollTrigger: {
      trigger: ".agt-wd-landing-video-wrapper",
      start: "top 80%", // start animation when section enters viewport
      end: "bottom+=50% top",
      scrub: true, // smooth scroll-based animation
      invalidateOnRefresh: true, // recalculates positions on resize/orientation change
    },
  });
  tl2.to(".agt-wd-landing-video-content-wrapper .agt-wd-landing-overlay", {
    y: -100,
    opacity: 0.75,
    scale: 1.05,
    duration: 2500,
    ease: "power2.out",
  });

  const tl3 = gsap.timeline({
    scrollTrigger: {
      trigger: ".agt-wd-collection-wrapper",
      start: "top 80%", // start animation when section enters viewport
      end: "bottom+=50% top",
      scrub: true, // smooth scroll-based animation
      invalidateOnRefresh: true, // recalculates positions on resize/orientation change
    },
  });

  // Animate IN
  tl3.to(".agt-item-collection-left-1", {
    x: 50,
    scale: 1,
    opacity: 1,
    duration: 2500,
    ease: "power2.out",
  });

  tl3.to(
    ".agt-item-collection-center-1",
    {
      y: 0,
      scale: 1,
      opacity: 1,
      duration: 1000,
      ease: "power2.out",
    },
    "<"
  ); // Start at the same time as above
  tl3.to(
    ".agt-item-collection-right-1",
    {
      x: -50,
      scale: 1,
      opacity: 1,
      duration: 2500,
      ease: "power2.out",
    },
    "<"
  );
  // Animate OUT (fade back to 0 after scroll)
  tl3.to(
    [
      ".agt-item-collection-left-1",
      ".agt-item-collection-center-1",
      ".agt-item-collection-right-1",
    ],
    {
      opacity: 1,
      scale: 1,
      duration: 0.4,
      ease: "power1.in",
    }
  );
}

$(".vpop").on("click", function (e) {
  e.preventDefault();
  $(
    "#video-popup-overlay,#video-popup-iframe-container,#video-popup-container,#video-popup-close"
  ).show();
  var srchref = "",
    autoplay = "0",
    id = $(this).data("id");

  if ($(this).data("type") == "vimeo")
    var srchref = "//player.vimeo.com/video/";
  else if ($(this).data("type") == "youtube")
    var srchref = "https://www.youtube.com/embed/";

  if ($(this).data("autoplay") == true) autoplay = "?autoplay=1";

  $("#video-popup-iframe").attr("src", srchref + id + autoplay);

  $("#video-popup-iframe").on("load", function () {
    $("#video-popup-container").show();
  });
});

$("#video-popup-close, #video-popup-overlay").on("click", function (e) {
  $(
    "#video-popup-iframe-container,#video-popup-container,#video-popup-close,#video-popup-overlay"
  ).hide();
  $("#video-popup-iframe").attr("src", "");
});
